<template>
  <div class="card modal-card-panier modal-card-border">
    <div class="card-content">
      <error-msg-component
      :messages="messageError"
      :error="errorPopup"
      title="Un problème est survenu"
      @close="error = $event"/>
      <section>
        <p class="subtitle is-5">Etes-vous sûr de vouloir supprimer cette opportunité ?</p>
      </section>
      <br>
      <footer>
        <div class="has-text-centered">
          <button class="button is-gris button-modal has-text-centered"
            @click="$emit('close')">
            Non
          </button>
          <button class="button is-primary button-modal has-text-centered"
            @click="$emit('yes')">
            Oui
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  name: 'suppression-op',
  props: {
    messageError: {
      type: Array,
      required: false,
    },
    errorPopup: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    errorMsgComponent,
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/mesOpportunites/supprimerOpportunite.vue